import classNames from "classnames";
import { dynamicFilterFilter } from "app/filters/dynamicFilter";
import { MarkerInnerWrapper } from "../styledComponents";

export const BenchmarkCompareLegendTemplate = (props) => {
    const { legendContainerClass, toggleSeries, legendItems, colors, getIcon } = props;
    const ImgComponent = (item) => {
        const iconItem = getIcon(item);
        return (
            iconItem && (
                <img
                    className={classNames("item-icon", {
                        "website-small-icon": item.smallIcon,
                    })}
                    id={item.id}
                    crossOrigin="anonymous"
                    src={iconItem}
                />
            )
        );
    };
    const IconComponent = (item) => <i className={classNames("item-icon", item.className)} />;

    return (
        <div className={classNames("legend", "legend-data", "compare", legendContainerClass)}>
            {legendItems?.map((item, index) => {
                const PictureComponent = (item) =>
                    item.iconType === "font" ? <IconComponent item={item} /> : <ImgComponent item={item} />;
                return (
                    <div
                        className={classNames(
                            "legend-item",
                            "no-padding-right",
                            { "legend-item--off": !!item.hidden },
                            { "legend-item--disabled": item.alwaysDisabled },
                        )}
                        onClick={() => toggleSeries(item, !!item.hidden)}
                        key={index}
                    >
                        <div className={classNames("legend-item-data", item.dataClass)}>
                            {dynamicFilterFilter()(item.data, item.format)}
                        </div>
                        <div className="site-image-and-name">
                            <span>
                                <PictureComponent item={item} />
                                <MarkerInnerWrapper
                                    className="item-marker--flat"
                                    color={item.color || item.Color || colors[index]}
                                />
                                <span
                                    className="item-name"
                                    title={item.name || item.Title}
                                >
                                    {item.name || item.Title}
                                </span>
                            </span>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
